import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonUse", "hasSearchbox", "isDisplayOptimized", "placement", "aria-invalid", "data-dropdown", "cssStyles", "dropdownStyles"];
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { AbstractDropdown } from './AbstractDropdown';
import { StyledButton } from '../Button/PrivateButton';
import { StyledImage } from '../Image/Image';
import { StyledView } from '../../../components/View/View';
import { StyledStatusDot } from '../StatusDot/StatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledDropdown = styled.div.withConfig({
  displayName: "AbstractDropdownWithSearchbox__StyledDropdown",
  componentId: "cm4hxb-0"
})(["", ""], ({
  $hasSearchbox,
  $arrowAtBottom,
  $arrowAtTop,
  $ariaInvalid,
  $buttonUse,
  $isDisplayOptimized,
  $dataDropdown,
  theme
}) => {
  const focusStyles = {
    outline: 'none !important',
    borderColor: 'rgba(0, 208, 228, 0.5) !important',
    boxShadow: '0 0 4px 1px rgba(0,208,228,0.3), 0 0 0 1px #00d0e4 !important'
  };
  const buttonFocusStyles = {
    [`&&& ${StyledButton}:focus, &&& ${StyledButton}:focus-visible`]: $buttonUse === 'form' || $buttonUse === 'form-on-dark' ? focusStyles : {
      outline: 'none !important'
    }
  };
  const commonStyles = {
    [`& ${StyledImage}`]: {
      marginInlineStart: theme.space['100'],
      marginInlineEnd: '6px' // no token for 6px
    },
    '&:not(:first-child)': {
      marginInlineStart: `-${theme.space['25']}`
    },
    [`& ${StyledStatusDot}`]: {
      marginInlineStart: theme.space['100'],
      marginInlineEnd: '6px' // no token for 6px
    },
    [`& ${StyledView}:has(${StyledStatusDot})`]: {
      marginInlineEnd: '6px' // no token for 6px
    }
  };
  const styles = {
    invalid: {
      [`& ${StyledButton}`]: {
        borderColor: theme.color['border-alert-default'],
        boxShadow: `0 0 0 1px ${theme.color['border-alert-default']}`
      }
    },
    noSearchbox: Object.assign({}, buttonFocusStyles, $dataDropdown && {
      display: 'inline-block',
      alignItems: 'center'
    }, {
      '&&': Object.assign({
        [`& ${StyledButton}`]: {}
      }, commonStyles)
    }),
    arrowBottom: {
      paddingTop: theme.space['0'],
      paddingBottom: theme.space['0']
    },
    arrowTop: {
      paddingTop: theme.space['0']
    },
    default: Object.assign({}, buttonFocusStyles, {
      '&&': Object.assign({
        [`& ${StyledButton}`]: {}
      }, commonStyles)
    })
  };
  if ($isDisplayOptimized) return {};
  if ($ariaInvalid) return styles.invalid;
  if (!$hasSearchbox) return styles.noSearchbox;
  if ($arrowAtBottom) return Object.assign({}, styles.arrowBottom, buttonFocusStyles);
  if ($arrowAtTop) return Object.assign({}, styles.arrowTop, buttonFocusStyles);
  return styles.default;
});
export class AbstractDropdownWithSearchbox extends Component {
  static getDerivedStateFromProps(props, state) {
    let derivedState = {};
    if (props.placement !== state.prevPlacement) {
      derivedState = Object.assign({}, derivedState, {
        placement: null,
        prevPlacement: props.placement
      });
    }
    if (props.open && !state.prevOpen) {
      derivedState = Object.assign({}, derivedState, {
        placement: null,
        prevOpen: props.open
      });
    } else if (props.open !== state.prevOpen) {
      derivedState = Object.assign({}, derivedState, {
        prevOpen: props.open
      });
    }
    return derivedState;
  }
  constructor(props) {
    var _props$open;
    super(props);
    this.handleChangePlacement = evt => {
      const {
        onChangePlacement
      } = this.props;
      const {
        newPlacement
      } = evt;
      if (this.state.placement !== newPlacement) {
        this.setState({
          placement: newPlacement
        });
      }
      if (onChangePlacement) onChangePlacement(evt);
    };
    this.state = {
      placement: null,
      prevPlacement: props.placement,
      prevOpen: (_props$open = props === null || props === void 0 ? void 0 : props.open) !== null && _props$open !== void 0 ? _props$open : false
    };
  }
  render() {
    const _this$props = this.props,
      {
        buttonUse,
        hasSearchbox,
        isDisplayOptimized,
        placement,
        'aria-invalid': ariaInvalid,
        'data-dropdown': dataDropdown,
        cssStyles,
        dropdownStyles
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      placement: placementState
    } = this.state;
    const defaultPlacement = buttonUse !== null && buttonUse !== void 0 && buttonUse.match(/link|transparent/) ? 'bottom' : 'bottom right';
    const computedPlacement = placementState || placement || defaultPlacement;
    const arrowAtBottom = computedPlacement.includes('bottom');
    const arrowAtTop = computedPlacement.includes('top');
    const computedArrowColor = hasSearchbox && arrowAtBottom ? 'fill-tertiary-default' : undefined;
    return /*#__PURE__*/_jsx(StyledDropdown, {
      $hasSearchbox: hasSearchbox !== null && hasSearchbox !== void 0 ? hasSearchbox : false,
      $arrowAtBottom: arrowAtBottom,
      $arrowAtTop: arrowAtTop,
      $ariaInvalid: ariaInvalid,
      $buttonUse: buttonUse,
      $isDisplayOptimized: isDisplayOptimized,
      $dataDropdown: dataDropdown,
      tabIndex: isDisplayOptimized ? undefined : 0,
      children: /*#__PURE__*/_jsx(AbstractDropdown, Object.assign({}, rest, {
        cssStyles: cssStyles,
        arrowColor: computedArrowColor,
        "aria-invalid": ariaInvalid,
        buttonUse: buttonUse,
        isDisplayOptimized: isDisplayOptimized,
        onChangePlacement: this.handleChangePlacement,
        placement: computedPlacement,
        autoPlacement: true,
        dropdownStyles: dropdownStyles
      }))
    });
  }
}